"use strict";

var _slicedToArray = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var common_1 = require("../common");

var Prototypes = require("./index");

var cache_1 = require("./cache");

var dataflow_1 = require("./dataflow");

var filter_1 = require("./filter");

var object_1 = require("./object");

var solver_1 = require("../solver");
/** Handles the life cycle of states and the dataflow */


var ChartStateManager =
/*#__PURE__*/
function () {
  function ChartStateManager(chart, dataset) {
    var state = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var defaultAttributes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, ChartStateManager);

    this.classCache = new cache_1.ObjectClassCache();
    this.idIndex = new Map();
    this.chart = chart;
    this.dataset = dataset;
    this.dataflow = new dataflow_1.DataflowManager(dataset);

    if (state == null) {
      this.initialize(defaultAttributes);
    } else {
      this.setState(state);
    }
  }
  /** Set an existing state */


  _createClass(ChartStateManager, [{
    key: "setState",
    value: function setState(state) {
      this.chartState = state;
      this.rebuildID2Object();
      this.initializeCache();
    }
    /** Set a new dataset, this will reset the state */

  }, {
    key: "setDataset",
    value: function setDataset(dataset) {
      this.dataset = dataset;
      this.dataflow = new dataflow_1.DataflowManager(dataset);
      this.initialize({});
    }
    /** Get data table by name */

  }, {
    key: "getTable",
    value: function getTable(name) {
      return this.dataflow.getTable(name);
    }
    /** Get an object by its unique ID */

  }, {
    key: "getObjectById",
    value: function getObjectById(id) {
      return this.idIndex.get(id)[0];
    }
    /** Get a chart-level element or scale by its id */

  }, {
    key: "getClassById",
    value: function getClassById(id) {
      var _this$idIndex$get = this.idIndex.get(id),
          _this$idIndex$get2 = _slicedToArray(_this$idIndex$get, 2),
          object = _this$idIndex$get2[0],
          state = _this$idIndex$get2[1];

      return this.classCache.getClass(state);
    }
    /** Get classes for chart elements */

  }, {
    key: "getElements",
    value: function getElements() {
      var _this = this;

      return common_1.zipArray(this.chart.elements, this.chartState.elements).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            element = _ref2[0],
            elementState = _ref2[1];

        return _this.classCache.getClass(elementState);
      });
    }
    /** Create an empty chart state using chart and dataset */

  }, {
    key: "createChartState",
    value: function createChartState() {
      var _this2 = this;

      var chart = this.chart; // Build the state hierarchy

      var elementStates = chart.elements.map(function (element) {
        // Initialie the element state
        var elementState = {
          attributes: {}
        }; // Special case for plot segment

        if (Prototypes.isType(element.classID, "plot-segment")) {
          _this2.mapPlotSegmentState(element, elementState);
        }

        return elementState;
      });
      var scaleStates = chart.scales.map(function (scale) {
        var state = {
          attributes: {}
        };
        return state;
      });
      return {
        elements: elementStates,
        scales: scaleStates,
        attributes: {}
      };
    }
    /** Initialize the object class cache */

  }, {
    key: "initializeCache",
    value: function initializeCache() {
      this.classCache = new cache_1.ObjectClassCache();
      var chartClass = this.classCache.createChartClass(null, this.chart, this.chartState);
      chartClass.setDataflow(this.dataflow);
      chartClass.setManager(this);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = common_1.zip(this.chart.scales, this.chartState.scales)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref7 = _step.value;

          var _ref4 = _slicedToArray(_ref7, 2);

          var scale = _ref4[0];
          var scaleState = _ref4[1];
          var scaleClass = this.classCache.createScaleClass(chartClass, scale, scaleState);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = common_1.zip(this.chart.elements, this.chartState.elements)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ref8 = _step2.value;

          var _ref6 = _slicedToArray(_ref8, 2);

          var element = _ref6[0];
          var elementState = _ref6[1];
          var elementClass = this.classCache.createChartElementClass(chartClass, element, elementState); // For plot segment, handle data mapping

          if (Prototypes.isType(element.classID, "plot-segment")) {
            this.initializePlotSegmentCache(element, elementState);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
    /** Enumerate all object classes */

  }, {
    key: "enumerateClasses",
    value: function enumerateClasses(callback) {
      var chartClass = this.classCache.getChartClass(this.chartState);
      callback(chartClass, this.chartState);
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = common_1.zip(this.chart.scales, this.chartState.scales)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _ref13 = _step3.value;

          var _ref10 = _slicedToArray(_ref13, 2);

          var scale = _ref10[0];
          var scaleState = _ref10[1];
          var scaleClass = this.classCache.getClass(scaleState);
          callback(scaleClass, scaleState);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = common_1.zip(this.chart.elements, this.chartState.elements)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _ref14 = _step4.value;

          var _ref12 = _slicedToArray(_ref14, 2);

          var element = _ref12[0];
          var elementState = _ref12[1];
          var elementClass = this.classCache.getClass(elementState);
          callback(elementClass, elementState); // For plot segment, handle data mapping

          if (Prototypes.isType(element.classID, "plot-segment")) {
            var plotSegment = element;
            var plotSegmentState = elementState;
            var glyph = this.getObjectById(plotSegment.glyph);
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
              for (var _iterator5 = plotSegmentState.glyphs[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                var glyphState = _step5.value;
                var glyphClass = this.classCache.getClass(glyphState);
                callback(glyphClass, glyphState);
                var _iteratorNormalCompletion6 = true;
                var _didIteratorError6 = false;
                var _iteratorError6 = undefined;

                try {
                  for (var _iterator6 = common_1.zip(glyph.marks, glyphState.marks)[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var _ref17 = _step6.value;

                    var _ref16 = _slicedToArray(_ref17, 2);

                    var mark = _ref16[0];
                    var markState = _ref16[1];
                    var markClass = this.classCache.getClass(markState);
                    callback(markClass, markState);
                  }
                } catch (err) {
                  _didIteratorError6 = true;
                  _iteratorError6 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
                      _iterator6.return();
                    }
                  } finally {
                    if (_didIteratorError6) {
                      throw _iteratorError6;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError5 = true;
              _iteratorError5 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                  _iterator5.return();
                }
              } finally {
                if (_didIteratorError5) {
                  throw _iteratorError5;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    }
    /** Enumerate classes, only return a specific type */

  }, {
    key: "enumerateClassesByType",
    value: function enumerateClassesByType(type, callback) {
      this.enumerateClasses(function (cls, state) {
        if (Prototypes.isType(cls.object.classID, type)) {
          callback(cls, state);
        }
      });
    }
  }, {
    key: "enumeratePlotSegments",
    value: function enumeratePlotSegments(callback) {
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = common_1.zip(this.chart.elements, this.chartState.elements)[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var _ref20 = _step7.value;

          var _ref19 = _slicedToArray(_ref20, 2);

          var element = _ref19[0];
          var elementState = _ref19[1];
          var elementClass = this.classCache.getClass(elementState);

          if (Prototypes.isType(element.classID, "plot-segment")) {
            callback(elementClass);
          }
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }
    }
    /** Initialize the chart state with default parameters */

  }, {
    key: "initializeState",
    value: function initializeState() {
      var defaultAttributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.enumerateClasses(function (cls) {
        cls.initializeState();
        var attributesToAdd = defaultAttributes[cls.object._id];

        if (attributesToAdd) {
          cls.state.attributes = Object.assign({}, cls.state.attributes, attributesToAdd);
        }
      });
    }
    /** Recreate the chart state from scratch */

  }, {
    key: "initialize",
    value: function initialize(defaultAttributes) {
      this.chartState = this.createChartState();
      this.rebuildID2Object();
      this.initializeCache();
      this.initializeState(defaultAttributes);
    }
    /** Rebuild id to object map */

  }, {
    key: "rebuildID2Object",
    value: function rebuildID2Object() {
      this.idIndex.clear(); // Chart elements

      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = common_1.zipArray(this.chart.elements, this.chartState.elements)[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var _ref25 = _step8.value;

          var _ref22 = _slicedToArray(_ref25, 2);

          var element = _ref22[0];
          var elementState = _ref22[1];
          this.idIndex.set(element._id, [element, elementState]);
        } // Scales

      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = common_1.zipArray(this.chart.scales, this.chartState.scales)[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var _ref26 = _step9.value;

          var _ref24 = _slicedToArray(_ref26, 2);

          var scale = _ref24[0];
          var scaleState = _ref24[1];
          this.idIndex.set(scale._id, [scale, scaleState]);
        } // Glyphs

      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = this.chart.glyphs[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var glyph = _step10.value;
          this.idIndex.set(glyph._id, [glyph, null]);
          var _iteratorNormalCompletion11 = true;
          var _didIteratorError11 = false;
          var _iteratorError11 = undefined;

          try {
            for (var _iterator11 = glyph.marks[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
              var _element = _step11.value;
              this.idIndex.set(_element._id, [_element, null]);
            }
          } catch (err) {
            _didIteratorError11 = true;
            _iteratorError11 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion11 && _iterator11.return != null) {
                _iterator11.return();
              }
            } finally {
              if (_didIteratorError11) {
                throw _iteratorError11;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }
    }
    /** Test if a name is already used */

  }, {
    key: "isNameUsed",
    value: function isNameUsed(candidate) {
      var chart = this.chart;
      var names = new Set();
      var _iteratorNormalCompletion12 = true;
      var _didIteratorError12 = false;
      var _iteratorError12 = undefined;

      try {
        for (var _iterator12 = chart.scales[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
          var scale = _step12.value;
          names.add(scale.properties.name);
        }
      } catch (err) {
        _didIteratorError12 = true;
        _iteratorError12 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion12 && _iterator12.return != null) {
            _iterator12.return();
          }
        } finally {
          if (_didIteratorError12) {
            throw _iteratorError12;
          }
        }
      }

      var _iteratorNormalCompletion13 = true;
      var _didIteratorError13 = false;
      var _iteratorError13 = undefined;

      try {
        for (var _iterator13 = chart.elements[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
          var element = _step13.value;
          names.add(element.properties.name);
        }
      } catch (err) {
        _didIteratorError13 = true;
        _iteratorError13 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion13 && _iterator13.return != null) {
            _iterator13.return();
          }
        } finally {
          if (_didIteratorError13) {
            throw _iteratorError13;
          }
        }
      }

      var _iteratorNormalCompletion14 = true;
      var _didIteratorError14 = false;
      var _iteratorError14 = undefined;

      try {
        for (var _iterator14 = chart.glyphs[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
          var mark = _step14.value;
          names.add(mark.properties.name);
          var _iteratorNormalCompletion15 = true;
          var _didIteratorError15 = false;
          var _iteratorError15 = undefined;

          try {
            for (var _iterator15 = mark.marks[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
              var _element2 = _step15.value;
              names.add(_element2.properties.name);
            }
          } catch (err) {
            _didIteratorError15 = true;
            _iteratorError15 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion15 && _iterator15.return != null) {
                _iterator15.return();
              }
            } finally {
              if (_didIteratorError15) {
                throw _iteratorError15;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError14 = true;
        _iteratorError14 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion14 && _iterator14.return != null) {
            _iterator14.return();
          }
        } finally {
          if (_didIteratorError14) {
            throw _iteratorError14;
          }
        }
      }

      return names.has(candidate);
    }
    /** Find an unused name given a prefix, will try prefix1, prefix2, and so on. */

  }, {
    key: "findUnusedName",
    value: function findUnusedName(prefix) {
      for (var i = 1;; i++) {
        var candidate = prefix + i.toString();

        if (!this.isNameUsed(candidate)) {
          return candidate;
        }
      }
    }
    /** Create a new object */

  }, {
    key: "createObject",
    value: function createObject(classID) {
      var _object_1$ObjectClass;

      var namePrefix = "Object";
      var metadata = object_1.ObjectClasses.GetMetadata(classID);

      if (metadata && metadata.displayName) {
        namePrefix = metadata.displayName;
      }

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var object = (_object_1$ObjectClass = object_1.ObjectClasses).CreateDefault.apply(_object_1$ObjectClass, [classID].concat(args));

      var name = this.findUnusedName(namePrefix);
      object.properties.name = name;
      return object;
    }
    /** Add a new glyph */

  }, {
    key: "addGlyph",
    value: function addGlyph(classID, table) {
      var newGlyph = {
        _id: common_1.uniqueID(),
        classID: classID,
        properties: {
          name: this.findUnusedName("Glyph")
        },
        table: table,
        marks: [{
          _id: common_1.uniqueID(),
          classID: "mark.anchor",
          properties: {
            name: "Anchor"
          },
          mappings: {
            x: {
              type: "parent",
              parentAttribute: "icx"
            },
            y: {
              type: "parent",
              parentAttribute: "icy"
            }
          }
        }],
        mappings: {},
        constraints: []
      };
      this.idIndex.set(newGlyph._id, [newGlyph, null]);
      this.idIndex.set(newGlyph.marks[0]._id, [newGlyph.marks[0], null]);
      this.chart.glyphs.push(newGlyph);
      return newGlyph;
    }
    /** Remove a glyph */

  }, {
    key: "removeGlyph",
    value: function removeGlyph(glyph) {
      var idx = this.chart.glyphs.indexOf(glyph);

      if (idx < 0) {
        return;
      }

      this.idIndex.delete(glyph._id);
      var _iteratorNormalCompletion16 = true;
      var _didIteratorError16 = false;
      var _iteratorError16 = undefined;

      try {
        for (var _iterator16 = glyph.marks[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
          var element = _step16.value;
          this.idIndex.delete(element._id);
        }
      } catch (err) {
        _didIteratorError16 = true;
        _iteratorError16 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion16 && _iterator16.return != null) {
            _iterator16.return();
          }
        } finally {
          if (_didIteratorError16) {
            throw _iteratorError16;
          }
        }
      }

      this.chart.glyphs.splice(idx, 1); // Delete all plot segments using this glyph

      var elementsToDelete = [];
      var _iteratorNormalCompletion17 = true;
      var _didIteratorError17 = false;
      var _iteratorError17 = undefined;

      try {
        for (var _iterator17 = this.chart.elements[Symbol.iterator](), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
          var _element3 = _step17.value;

          if (Prototypes.isType(_element3.classID, "plot-segment")) {
            var plotSegment = _element3;

            if (plotSegment.glyph == glyph._id) {
              elementsToDelete.push(plotSegment);
            }
          }
        }
      } catch (err) {
        _didIteratorError17 = true;
        _iteratorError17 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion17 && _iterator17.return != null) {
            _iterator17.return();
          }
        } finally {
          if (_didIteratorError17) {
            throw _iteratorError17;
          }
        }
      }

      for (var _i = 0, _elementsToDelete = elementsToDelete; _i < _elementsToDelete.length; _i++) {
        var _plotSegment = _elementsToDelete[_i];
        this.removeChartElement(_plotSegment);
      }
    }
    /** Add a new element to a glyph */

  }, {
    key: "addMarkToGlyph",
    value: function addMarkToGlyph(mark, glyph) {
      var _this3 = this;

      glyph.marks.push(mark); // Create element state in all plot segments using this glyph

      this.enumeratePlotSegments(function (plotSegmentClass) {
        if (plotSegmentClass.object.glyph == glyph._id) {
          var _iteratorNormalCompletion18 = true;
          var _didIteratorError18 = false;
          var _iteratorError18 = undefined;

          try {
            for (var _iterator18 = plotSegmentClass.state.glyphs[Symbol.iterator](), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
              var glyphState = _step18.value;

              var glyphClass = _this3.classCache.getGlyphClass(glyphState);

              var markState = {
                attributes: {}
              };
              glyphState.marks.push(markState);

              var markClass = _this3.classCache.createMarkClass(glyphClass, mark, markState);

              markClass.initializeState();
            }
          } catch (err) {
            _didIteratorError18 = true;
            _iteratorError18 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion18 && _iterator18.return != null) {
                _iterator18.return();
              }
            } finally {
              if (_didIteratorError18) {
                throw _iteratorError18;
              }
            }
          }
        }
      });
    }
    /** Remove an element from a glyph */

  }, {
    key: "removeMarkFromGlyph",
    value: function removeMarkFromGlyph(mark, glyph) {
      var idx = glyph.marks.indexOf(mark);

      if (idx < 0) {
        return;
      }

      glyph.marks.splice(idx, 1);
      glyph.constraints = this.validateConstraints(glyph.constraints, glyph.marks);
      this.idIndex.delete(mark._id); // Remove the element state from all elements using this glyph

      this.enumeratePlotSegments(function (plotSegmentClass) {
        if (plotSegmentClass.object.glyph == glyph._id) {
          var _iteratorNormalCompletion19 = true;
          var _didIteratorError19 = false;
          var _iteratorError19 = undefined;

          try {
            for (var _iterator19 = plotSegmentClass.state.glyphs[Symbol.iterator](), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
              var glyphState = _step19.value;
              glyphState.marks.splice(idx, 1);
            }
          } catch (err) {
            _didIteratorError19 = true;
            _iteratorError19 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion19 && _iterator19.return != null) {
                _iterator19.return();
              }
            } finally {
              if (_didIteratorError19) {
                throw _iteratorError19;
              }
            }
          }
        }
      });
    }
    /** Add a chart element */

  }, {
    key: "addChartElement",
    value: function addChartElement(element) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var elementState = {
        attributes: {}
      };

      if (Prototypes.isType(element.classID, "plot-segment")) {
        this.mapPlotSegmentState(element, elementState);
      }

      if (index != null && index >= 0 && index <= this.chart.elements.length) {
        this.chart.elements.splice(index, 0, element);
        this.chartState.elements.splice(index, 0, elementState);
      } else {
        this.chart.elements.push(element);
        this.chartState.elements.push(elementState);
      }

      var elementClass = this.classCache.createChartElementClass(this.classCache.getChartClass(this.chartState), element, elementState);

      if (Prototypes.isType(element.classID, "plot-segment")) {
        this.initializePlotSegmentCache(element, elementState);
      }

      elementClass.initializeState();

      if (Prototypes.isType(element.classID, "plot-segment")) {
        this.initializePlotSegmentState(elementClass);
      }

      this.idIndex.set(element._id, [element, elementState]);
    }
  }, {
    key: "reorderArray",
    value: function reorderArray(array, fromIndex, toIndex) {
      var x = array.splice(fromIndex, 1)[0];

      if (fromIndex < toIndex) {
        array.splice(toIndex - 1, 0, x);
      } else {
        array.splice(toIndex, 0, x);
      }
    }
  }, {
    key: "reorderChartElement",
    value: function reorderChartElement(fromIndex, toIndex) {
      if (toIndex == fromIndex || toIndex == fromIndex + 1) {
        return;
      } // no effect


      this.reorderArray(this.chart.elements, fromIndex, toIndex);
      this.reorderArray(this.chartState.elements, fromIndex, toIndex);
    }
  }, {
    key: "reorderGlyphElement",
    value: function reorderGlyphElement(glyph, fromIndex, toIndex) {
      if (toIndex == fromIndex || toIndex == fromIndex + 1) {
        return;
      } // no effect


      var _iteratorNormalCompletion20 = true;
      var _didIteratorError20 = false;
      var _iteratorError20 = undefined;

      try {
        for (var _iterator20 = common_1.zip(this.chart.elements, this.chartState.elements)[Symbol.iterator](), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
          var _ref29 = _step20.value;

          var _ref28 = _slicedToArray(_ref29, 2);

          var element = _ref28[0];
          var elementState = _ref28[1];

          if (Prototypes.isType(element.classID, "plot-segment")) {
            var plotSegment = element;
            var plotSegmentState = elementState;

            if (plotSegment.glyph == glyph._id) {
              var _iteratorNormalCompletion21 = true;
              var _didIteratorError21 = false;
              var _iteratorError21 = undefined;

              try {
                for (var _iterator21 = plotSegmentState.glyphs[Symbol.iterator](), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
                  var glyphState = _step21.value;
                  this.reorderArray(glyphState.marks, fromIndex, toIndex);
                }
              } catch (err) {
                _didIteratorError21 = true;
                _iteratorError21 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion21 && _iterator21.return != null) {
                    _iterator21.return();
                  }
                } finally {
                  if (_didIteratorError21) {
                    throw _iteratorError21;
                  }
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError20 = true;
        _iteratorError20 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion20 && _iterator20.return != null) {
            _iterator20.return();
          }
        } finally {
          if (_didIteratorError20) {
            throw _iteratorError20;
          }
        }
      }

      this.reorderArray(glyph.marks, fromIndex, toIndex);
    }
    /**
     * Map/remap plot segment glyphs
     * @param plotSegment
     * @param plotSegmentState
     */

  }, {
    key: "mapPlotSegmentState",
    value: function mapPlotSegmentState(plotSegment, plotSegmentState) {
      var glyphObject = common_1.getById(this.chart.glyphs, plotSegment.glyph);
      var table = this.getTable(glyphObject.table);
      var index2ExistingGlyphState = new Map();

      if (plotSegmentState.dataRowIndices) {
        var _iteratorNormalCompletion22 = true;
        var _didIteratorError22 = false;
        var _iteratorError22 = undefined;

        try {
          for (var _iterator22 = common_1.zip(plotSegmentState.dataRowIndices, plotSegmentState.glyphs)[Symbol.iterator](), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
            var _ref32 = _step22.value;

            var _ref31 = _slicedToArray(_ref32, 2);

            var rowIndex = _ref31[0];
            var glyphState = _ref31[1];
            index2ExistingGlyphState.set(rowIndex.join(","), glyphState);
          }
        } catch (err) {
          _didIteratorError22 = true;
          _iteratorError22 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion22 && _iterator22.return != null) {
              _iterator22.return();
            }
          } finally {
            if (_didIteratorError22) {
              throw _iteratorError22;
            }
          }
        }
      }

      var filteredIndices = table.rows.map(function (r, i) {
        return i;
      });

      if (plotSegment.filter) {
        var filter = new filter_1.CompiledFilter(plotSegment.filter, this.dataflow.cache);
        filteredIndices = filteredIndices.filter(function (i) {
          return filter.filter(table.getRowContext(i));
        });
      }

      if (plotSegment.groupBy) {
        if (plotSegment.groupBy.expression) {
          var expr = this.dataflow.cache.parse(plotSegment.groupBy.expression);
          var groups = new Map();
          plotSegmentState.dataRowIndices = [];
          var _iteratorNormalCompletion23 = true;
          var _didIteratorError23 = false;
          var _iteratorError23 = undefined;

          try {
            for (var _iterator23 = filteredIndices[Symbol.iterator](), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
              var i = _step23.value;
              var groupBy = expr.getStringValue(table.getRowContext(i));

              if (groups.has(groupBy)) {
                groups.get(groupBy).push(i);
              } else {
                var g = [i];
                groups.set(groupBy, g);
                plotSegmentState.dataRowIndices.push(g);
              }
            }
          } catch (err) {
            _didIteratorError23 = true;
            _iteratorError23 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion23 && _iterator23.return != null) {
                _iterator23.return();
              }
            } finally {
              if (_didIteratorError23) {
                throw _iteratorError23;
              }
            }
          }
        } else {// TODO: emit error
        }
      } else {
        plotSegmentState.dataRowIndices = filteredIndices.map(function (i) {
          return [i];
        });
      } // Resolve filter


      plotSegmentState.glyphs = plotSegmentState.dataRowIndices.map(function (rowIndex) {
        if (index2ExistingGlyphState.has(rowIndex.join(","))) {
          return index2ExistingGlyphState.get(rowIndex.join(","));
        } else {
          var _glyphState = {
            marks: glyphObject.marks.map(function () {
              var elementState = {
                attributes: {}
              };
              return elementState;
            }),
            attributes: {}
          };
          return _glyphState;
        }
      });
    }
  }, {
    key: "initializePlotSegmentCache",
    value: function initializePlotSegmentCache(element, elementState) {
      var plotSegment = element;
      var plotSegmentState = elementState;
      var plotSegmentClass = this.classCache.getPlotSegmentClass(plotSegmentState);
      var glyph = this.getObjectById(plotSegment.glyph);
      var _iteratorNormalCompletion24 = true;
      var _didIteratorError24 = false;
      var _iteratorError24 = undefined;

      try {
        for (var _iterator24 = plotSegmentState.glyphs[Symbol.iterator](), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
          var glyphState = _step24.value;

          if (this.classCache.hasClass(glyphState)) {
            continue;
          }

          var glyphClass = this.classCache.createGlyphClass(plotSegmentClass, glyph, glyphState);
          var _iteratorNormalCompletion25 = true;
          var _didIteratorError25 = false;
          var _iteratorError25 = undefined;

          try {
            for (var _iterator25 = common_1.zip(glyph.marks, glyphState.marks)[Symbol.iterator](), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
              var _ref35 = _step25.value;

              var _ref34 = _slicedToArray(_ref35, 2);

              var mark = _ref34[0];
              var markState = _ref34[1];
              var markClass = this.classCache.createMarkClass(glyphClass, mark, markState);
            }
          } catch (err) {
            _didIteratorError25 = true;
            _iteratorError25 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion25 && _iterator25.return != null) {
                _iterator25.return();
              }
            } finally {
              if (_didIteratorError25) {
                throw _iteratorError25;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError24 = true;
        _iteratorError24 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion24 && _iterator24.return != null) {
            _iterator24.return();
          }
        } finally {
          if (_didIteratorError24) {
            throw _iteratorError24;
          }
        }
      }
    }
  }, {
    key: "initializePlotSegmentState",
    value: function initializePlotSegmentState(plotSegmentClass) {
      var glyph = this.getObjectById(plotSegmentClass.object.glyph);
      var _iteratorNormalCompletion26 = true;
      var _didIteratorError26 = false;
      var _iteratorError26 = undefined;

      try {
        for (var _iterator26 = plotSegmentClass.state.glyphs[Symbol.iterator](), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
          var glyphState = _step26.value;
          var glyphClass = this.classCache.getGlyphClass(glyphState);
          glyphClass.initializeState();
          var _iteratorNormalCompletion27 = true;
          var _didIteratorError27 = false;
          var _iteratorError27 = undefined;

          try {
            for (var _iterator27 = common_1.zip(glyph.marks, glyphState.marks)[Symbol.iterator](), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
              var _ref38 = _step27.value;

              var _ref37 = _slicedToArray(_ref38, 2);

              var mark = _ref37[0];
              var markState = _ref37[1];
              var markClass = this.classCache.getMarkClass(markState);
              markClass.initializeState();
            }
          } catch (err) {
            _didIteratorError27 = true;
            _iteratorError27 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion27 && _iterator27.return != null) {
                _iterator27.return();
              }
            } finally {
              if (_didIteratorError27) {
                throw _iteratorError27;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError26 = true;
        _iteratorError26 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion26 && _iterator26.return != null) {
            _iterator26.return();
          }
        } finally {
          if (_didIteratorError26) {
            throw _iteratorError26;
          }
        }
      }
    }
    /** Remove a chart element */

  }, {
    key: "removeChartElement",
    value: function removeChartElement(element) {
      var idx = this.chart.elements.indexOf(element);

      if (idx < 0) {
        return;
      }

      this.chart.elements.splice(idx, 1);
      this.chartState.elements.splice(idx, 1);
      this.idIndex.delete(element._id);
      this.chart.constraints = this.validateConstraints(this.chart.constraints, this.chart.elements);
    }
  }, {
    key: "remapPlotSegmentGlyphs",
    value: function remapPlotSegmentGlyphs(plotSegment) {
      var idx = this.chart.elements.indexOf(plotSegment);

      if (idx < 0) {
        return;
      }

      var plotSegmentState = this.chartState.elements[idx];
      this.mapPlotSegmentState(plotSegment, plotSegmentState);
      this.initializePlotSegmentCache(plotSegment, plotSegmentState);
    }
    /** Add a new scale */

  }, {
    key: "addScale",
    value: function addScale(scale) {
      var scaleState = {
        attributes: {}
      };
      this.chart.scales.push(scale);
      this.chartState.scales.push(scaleState);
      var scaleClass = this.classCache.createScaleClass(this.classCache.getChartClass(this.chartState), scale, scaleState);
      scaleClass.initializeState();
      this.idIndex.set(scale._id, [scale, scaleState]);
    }
    /** Remove a scale */

  }, {
    key: "removeScale",
    value: function removeScale(scale) {
      var idx = this.chart.scales.indexOf(scale);

      if (idx < 0) {
        return;
      }

      this.chart.scales.splice(idx, 1);
      this.chartState.scales.splice(idx, 1);
      this.idIndex.delete(scale._id);
    }
  }, {
    key: "getMarkClass",
    value: function getMarkClass(state) {
      return this.classCache.getMarkClass(state);
    }
  }, {
    key: "getGlyphClass",
    value: function getGlyphClass(state) {
      return this.classCache.getGlyphClass(state);
    }
  }, {
    key: "getChartElementClass",
    value: function getChartElementClass(state) {
      return this.classCache.getChartElementClass(state);
    }
  }, {
    key: "getPlotSegmentClass",
    value: function getPlotSegmentClass(state) {
      return this.classCache.getPlotSegmentClass(state);
    }
  }, {
    key: "getScaleClass",
    value: function getScaleClass(state) {
      return this.classCache.getScaleClass(state);
    }
  }, {
    key: "getChartClass",
    value: function getChartClass(state) {
      return this.classCache.getChartClass(state);
    }
  }, {
    key: "getClass",
    value: function getClass(state) {
      return this.classCache.getClass(state);
    }
  }, {
    key: "findGlyphState",
    value: function findGlyphState(plotSegment, glyph) {
      var glyphIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      if (glyphIndex == null) {
        glyphIndex = 0;
      }

      var plotSegmentClass = this.getClassById(plotSegment._id);
      return plotSegmentClass.state.glyphs[glyphIndex];
    }
  }, {
    key: "findMarkState",
    value: function findMarkState(plotSegment, glyph, mark) {
      var glyphIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var markIndex = glyph.marks.indexOf(mark);
      return this.findGlyphState(plotSegment, glyph, glyphIndex).marks[markIndex];
    }
    /** Remove constraints that relate to non-existant element */

  }, {
    key: "validateConstraints",
    value: function validateConstraints(constraints, elements) {
      var elementIDs = new Set();
      var _iteratorNormalCompletion28 = true;
      var _didIteratorError28 = false;
      var _iteratorError28 = undefined;

      try {
        for (var _iterator28 = elements[Symbol.iterator](), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
          var e = _step28.value;
          elementIDs.add(e._id);
        }
      } catch (err) {
        _didIteratorError28 = true;
        _iteratorError28 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion28 && _iterator28.return != null) {
            _iterator28.return();
          }
        } finally {
          if (_didIteratorError28) {
            throw _iteratorError28;
          }
        }
      }

      return constraints.filter(function (constraint) {
        switch (constraint.type) {
          case "snap":
            {
              return elementIDs.has(constraint.attributes.element) && elementIDs.has(constraint.attributes.targetElement);
            }

          default:
            return true;
        }
      });
    }
  }, {
    key: "resolveResource",
    value: function resolveResource(description) {
      var m = description.match(/^resource\:([.*]+)$/);

      if (m && this.chart.resources) {
        var id = m[1];
        var _iteratorNormalCompletion29 = true;
        var _didIteratorError29 = false;
        var _iteratorError29 = undefined;

        try {
          for (var _iterator29 = this.chart.resources[Symbol.iterator](), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
            var item = _step29.value;

            if (item.id == id) {
              return item.data;
            }
          }
        } catch (err) {
          _didIteratorError29 = true;
          _iteratorError29 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion29 && _iterator29.return != null) {
              _iterator29.return();
            }
          } finally {
            if (_didIteratorError29) {
              throw _iteratorError29;
            }
          }
        }
      } else {
        return description;
      }
    }
    /** Get chart-level data context for a given table */

  }, {
    key: "getChartDataContext",
    value: function getChartDataContext(tableName) {
      if (tableName == null) {
        return null;
      }

      var table = this.dataflow.getTable(tableName);
      return table.getGroupedContext(common_1.makeRange(0, table.rows.length));
    }
    /** Get glyph-level data context for the glyphIndex-th glyph */

  }, {
    key: "getGlpyhDataContext",
    value: function getGlpyhDataContext(plotSegment, glyphIndex) {
      var table = this.dataflow.getTable(plotSegment.table);
      var plotSegmentClass = this.getClassById(plotSegment._id);
      var indices = plotSegmentClass.state.dataRowIndices[glyphIndex];
      return table.getGroupedContext(indices);
    }
    /** Get all glyph-level data contexts for a given plot segment */

  }, {
    key: "getGlpyhDataContexts",
    value: function getGlpyhDataContexts(plotSegment, glyphIndex) {
      var table = this.dataflow.getTable(plotSegment.table);
      var plotSegmentClass = this.getClassById(plotSegment._id);
      return plotSegmentClass.state.dataRowIndices.map(function (indices) {
        return table.getGroupedContext(indices);
      });
    }
  }, {
    key: "getGroupedExpressionVector",
    value: function getGroupedExpressionVector(tableName, groupBy, expression) {
      var expr = this.dataflow.cache.parse(expression);
      var table = this.dataflow.getTable(tableName);

      if (!table) {
        return [];
      }

      var indices = [];

      for (var i = 0; i < table.rows.length; i++) {
        indices.push(i);
      }

      if (groupBy && groupBy.expression) {
        var groupExpression = this.dataflow.cache.parse(groupBy.expression);
        var groups = common_1.gather(indices, function (i) {
          return groupExpression.getStringValue(table.getRowContext(i));
        });
        return groups.map(function (g) {
          return expr.getValue(table.getGroupedContext(g));
        });
      } else {
        return indices.map(function (i) {
          return expr.getValue(table.getGroupedContext([i]));
        });
      }
    }
  }, {
    key: "solveConstraints",
    value: function solveConstraints() {
      var additional = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var mappingOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (mappingOnly) {
        var solver = new solver_1.ChartConstraintSolver("glyphs");
        solver.setup(this);
        solver.destroy();
      } else {
        var iterations = additional != null ? 2 : 1;
        var phases = ["chart", "glyphs"];

        for (var i = 0; i < iterations; i++) {
          for (var _i2 = 0, _phases = phases; _i2 < _phases.length; _i2++) {
            var phase = _phases[_i2];

            var _solver = new solver_1.ChartConstraintSolver(phase);

            _solver.setup(this);

            if (additional) {
              additional(_solver);
            }

            _solver.solve();

            _solver.destroy();
          }

          additional = null;
        }
      }
    }
  }]);

  return ChartStateManager;
}();

exports.ChartStateManager = ChartStateManager;